import React from "react";
import { Button, Col, Form, FormControl, InputGroup, Row } from "react-bootstrap";
import isEmpty from 'lodash/isEmpty';

export const PriceSetting = ({ price, row, namePrefix, onDelete, onChange }) => {
    return <Form.Group as={Row}>
        <Form.Group as={Col}>
            <InputGroup>
                <FormControl placeholder='最低価格' value={price.minimum} type='number'
                    onChange={e => onChange({ minimum: e.target.value })}
                    name={`${namePrefix}[${row}][minimum]`}
                    isInvalid={isEmpty(price.minimum) || price.minimum < 1}
                    min={1}
                />
                <InputGroup.Text>円</InputGroup.Text>
            </InputGroup>
            <Form.Control.Feedback type="invalid">
                1円以上の値を設定してください
            </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col}>
            <InputGroup>
                <FormControl placeholder='最高価格(省略可)' value={price.maximum} type='number'
                    onChange={e => onChange({ maximum: e.target.value })}
                    name={`${namePrefix}[${row}][maximum]`}
                />
                <InputGroup.Text>円</InputGroup.Text>
            </InputGroup>
        </Form.Group>
        <Form.Group as={Col}>
            <InputGroup>
                <FormControl placeholder='係数(必須)' value={price.rate} type='number'
                    onChange={e => onChange({ rate: e.target.value })}
                    name={`${namePrefix}[${row}][rate]`}
                    min={10}
                />
                <InputGroup.Text>%</InputGroup.Text>
            </InputGroup>
            <Form.Control.Feedback type="invalid">
                10%以上の値を設定してください
            </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col}>
            <InputGroup>
                <FormControl placeholder='定数' value={price.constant} type='number'
                    onChange={e => onChange({ constant: e.target.value })}
                    name={`${namePrefix}[${row}][constant]`}
                />
                <InputGroup.Text>円</InputGroup.Text>
            </InputGroup>
        </Form.Group>
        <Form.Group as={Col}>
            <Button variant="danger" onClick={_ => onDelete(row)}>削除</Button>
        </Form.Group>
    </Form.Group>;
}
